// Module
var code = "<p>Direct Debit is a convenient, effortless way to make your student loan payments.</p> ";
// Exports
export default code;